module.exports = __webpack_public_path__ + "img/b_19_s.70e9fc50.jpg";